export default "__VITE_ASSET__f56PX1NC__"